import { SVGProps, Ref, forwardRef } from 'react';

export const EyeFilledSize16Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={16} height={16} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <path
                d="M6.99 7.061c-.14.17-.258.479-.258.937s.117.767.259.937c.104.124.344.329 1.007.329s.903-.205 1.007-.33c.142-.169.259-.477.259-.936 0-.458-.117-.767-.259-.937-.104-.124-.344-.329-1.007-.329s-.903.205-1.007.33"
                fill="currentColor"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M0 8c.333-1.375 3.5-5.5 8-5.5s7.667 4.125 8 5.5c-.333 1.375-3.5 5.5-8 5.5S.333 9.375 0 8m7.998-2.668c-2 0-2.666 1.333-2.666 2.666s.667 2.666 2.666 2.666c2 0 2.666-1.333 2.666-2.666s-.666-2.666-2.666-2.666"
                fill="currentColor"
            />
        </g>
    </svg>
));
EyeFilledSize16Glyph.displayName = 'EyeFilledSize16Glyph';
